import { render, staticRenderFns } from "./RefundForm.vue?vue&type=template&id=1784a220&scoped=true&"
import script from "./RefundForm.vue?vue&type=script&lang=js&"
export * from "./RefundForm.vue?vue&type=script&lang=js&"
import style0 from "./RefundForm.vue?vue&type=style&index=0&id=1784a220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784a220",
  null
  
)

export default component.exports